export const encryptionSets = [
  {
    "name": "Fata Morgana",
    "abc": "KY7DRNI4J92WVMEHU6OXSC1T8BPFGQAL0Z35",
    "metadataAbc": "X9HUNIKE12YSZWC6T7LAO3BDJM05R48FVGPQ"
  },
  {
    "name": "Fieber",
    "abc": "KDQ8L0GFJI3W7B9OSHAPV6ERZM1YNUC25T4X",
    "metadataAbc": "KDUF7A3JMIXH8QS2GREC4NZ10V569YOTLPBW"
  },
  {
    "name": "Anthrazit",
    "abc": "I95H1TDK6FJQNL3CMYBR8AZ0EX2OWSUG47VP",
    "metadataAbc": "ZSU2YD51HQNPABVF9WTKEM8RJ43L7G06OCIX"
  },
  {
    "name": "Resume Worte",
    "abc": "RZI49S1FKOJNU75Q2EM6YAHW0GPTCDX3BL8V",
    "metadataAbc": "2FL6ZE178DWOIR4BKSHY5JXGUAMN930QPVCT"
  },
  {
    "name": "Resume Risiko",
    "abc": "VQM4I5KPLGEX1NADYFHZJ0W637928OSBRTUC",
    "metadataAbc": "5I9X2OEA6CULRDSK7ZP4FGTBN1WJHQY38M0V"
  },
  {
    "name": "DArkSide",
    "abc": "XEGFCOAVT1YQ0ZSHL28BI9WPKN5RD6U3J47M",
    "metadataAbc": "1Y4Q5ROLUW2DGITBMCJXSN7FP0HK36E9ZVA8"
  },
  {
    "name": "Démon Mode",
    "abc": "TEG8FIRUALCQZHMYD1BPSWOJVX47N39K6025",
    "metadataAbc": "ID5ZCKS39FP4VWYN61R0EGMTL2HABXO8UQJ7"
  },
  {
    "name": "Statement",
    "abc": "SM0ZUT78C6QDE4B2PFHANLVRIXWK59OGJ31Y",
    "metadataAbc": "DBJHKXF584UM0CTAVOEP3I2QN7ZRSY9LW1G6"
  },
  {
    "name": "Freisen",
    "abc": "28SJO0GC9NRYFLP3BHXMZWEADQT41K6I5UV7",
    "metadataAbc": "OSHK4WCG3MTQ68J0L7VNBFPADXIE1ZUR52Y9"
  },
  {
    "name": "Lion",
    "abc": "P0EI9J26ZW1KNB38XTFR5LGVOQ7MHUYACSD4",
    "metadataAbc": "SO74QHPDW3I05ZEM1FRLC8V6NUAYTKX29GBJ"
  },
  {
    "name": "Keine Fragen",
    "abc": "N2G3I0RYJ61EWMV8OKF9BAT47ZCSXPUQD5LH",
    "metadataAbc": "3OI6JEAXW98ZDPBHG7F4T0QS5VKM2LYUNCR1"
  },
  {
    "name": "Painkiller",
    "abc": "G4MWSI5VERH2B0X36LKYCD1F9ZNPAUT78QOJ",
    "metadataAbc": "U9ZWH0QDLGJSP6FCE2XOYA7I84KN3T1R5MVB"
  },
  {
    "name": "The Diary Of Jane",
    "abc": "S3JRYPAQKLTUW6HM2VZEOCI49BDF158N0XG7",
    "metadataAbc": "RLPFU7OS506HKG3QJZ84XAIVWTB1YDN29CME"
  },
  {
    "name": "The Ghost of You",
    "abc": "IQSLYKMOEGDXP2W5FVCNZ9RU30AB7JTH6148",
    "metadataAbc": "0HNDCSPMWJTU6K8YFXGZRO2AIL715E3Q4V9B"
  },
  {
    "name": "Ich will dich vermissen",
    "abc": "SEI7PMGT21HQN038OBUVLWFR9Y6AZJCKDX45",
    "metadataAbc": "130H6WSPBDI2M845GL79TQYJERUZVKACNXOF"
  }
]
